import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent implements ControlValueAccessor {
  @Input() label!: string;
  @Input() iconSrc?: string;
  @Input() icon?: string;
  @Input() type = 'text';
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() description?: string;
  @Input() errorMessages: string[] = [];

  protected _value = '';
  protected showPassword = false;

  constructor(@Self() @Optional() public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: string): void {
    this._value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    if (value !== this._value) {
      this._value = value;
      this.onChange(value);
    }
    this.onTouched();
  }

  public getValidationNgClasses(
    control: NgControl
  ): Record<string, boolean | null> {
    return {
      'ng-invalid': control?.invalid,
      'ng-valid': control?.valid,
      'ng-touched': control?.touched,
      'ng-untouched': !control?.touched,
      'ng-dirty': control?.dirty,
      'ng-pristine': control?.pristine,
    };
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  public getPasswordFieldType(): string {
    return this.showPassword ? 'text' : 'password';
  }
}
